export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.contactOptions = payload;

  return newState;
};
